/**
 * Created by andrey on 24.12.2020.
 */

const EditorMap2dInnerView = Map2dInnerView.extend({
    ctor: function (map2d) {
        this._super(map2d);

        this.aboveGround = new cc.Node();
        this.aboveGround.setContentSize(this.getContentSize());
        this.aboveGround.setAlignment(this.width / 2, this.height / 2);
        this.aboveGround.setAnchorPoint(0.5, 0.5);
        this.tiles.addChild(this.aboveGround, Map2d.ABOVE_GROUND);

        this.isVisiblePoint = () => true;

        if (map2d.reference.isAvailable()) {
            const referenceView = new EditorMap2dReferenceView(map2d.reference);
            this.addChild(referenceView);
            referenceView.updatePosition();
        }

        const highlight = new Highlight(0, 0);

        const orangery = Editor.currentEditor.orangery;
        if (orangery.isBrushModeAvailable()) {
            const updateHighlightShape = () => {
                highlight.setShape(orangery.isBrushMode() ? orangery.getBrushShape() : FamiliesHelper.ShapeCell);
            };

            orangery.on("changeBrushSize", updateHighlightShape, this);
            orangery.on("toggleBrushMode", updateHighlightShape, this);
        }

        this.highlight = new HighlightView(highlight);
        this.aboveGround.addChild(this.highlight);

        this.addChild(new EditorMap2dBoundsView(Editor.currentEditor, this), 10);

        map2d.on("removeValue", this.onRemoveValue.bind(this), this);
        map2d.on("setValue", this.onSetValue.bind(this), this);
    },

    getVisibleCellByCoordinates: function (p) {
        const cell = this.getCellByCoordinates(p);
        if (this.map2d.containsCell(cell) && this.isVisiblePoint(p)) {
            return cell;
        }
    },

    createView: function (object) {
        if (object instanceof EditorFogTile) {
            return new EditorFogTileView(object);
        }
        if (object instanceof Unit && !object.isMultiCellBody() && Map2d.unitsVisible) {
            return new EditorUnitView(object);
        }
        if (object === Map2d.TILE_WATER_UNIT && Map2d.groundVisible) {
            const tilesTexture = Map2d.getTilesTexture(Map2d.currentMap && Map2d.currentMap.tilesSkin);
            const frame = bundles[tilesTexture] && bundles[tilesTexture].frames.water;
            if (frame) {
                const water = new cc.Sprite(frame);
                water.setColor(new cc.Color(100, 100, 100, 255));
                return water;
            }
        }

        return this._super(object);
    },

    getLayersOrder: function () {
        return [
            [Map2d.LAYER_WATER],
            [Map2d.LAYER_BORDERS],
            [Map2d.LAYER_GROUND],
            [Map2d.ABOVE_GROUND],
            [Map2d.LAYER_UNITS],
            [Map2d.LAYER_FOG]
        ];
    },

    addControls: function () {
        this.editorControlsNode = new cc.Node();
        this.editorControlsNode.setContentSize2(this.width, this.height);
        this.editorControlsNode.setAnchorPoint(0.5, 0.5);
        this.editorControlsNode.setAlignment({ align: "center" }, { align: "center" });
        this.addChild(this.editorControlsNode, -1);

        this.addHighlightListener();
        this.addDragAndProduceListener();
        this.addBrushKeyListener();
    },

    addBrushKeyListener: function () {
        const orangery = Editor.currentEditor.orangery;

        cleverapps.inputDispatcher.on("keypressed", (key) => {
            if (key === InputDispatcher.KEY.b && !orangery.isBrushMode()) {
                orangery.toggleBrushMode();
                this.brushKeyActivated = true;
            }
        }, this.editorControlsNode);

        cleverapps.inputDispatcher.on("keyreleased", (key) => {
            if (key === InputDispatcher.KEY.b && this.brushKeyActivated) {
                orangery.toggleBrushMode();
                this.brushKeyActivated = false;
            }
        }, this.editorControlsNode);
    },

    addHighlightListener: function () {
        cleverapps.pointerManager.create(this.editorControlsNode, {
            interactiveScale: false,
            onMouseMove: (touch) => {
                const p = this.convertTouchToNodeSpace(touch);
                const cell = this.getVisibleCellByCoordinates(p);
                const x = cell && cell.x || 0;
                const y = cell && cell.y || 0;

                if (Editor.currentEditor.selected && !this.draggable) {
                    this.highlight.setVisible(true);
                    this.highlight.highlight.move(x, y, true);
                } else {
                    this.highlight.setVisible(false);
                }
            }
        });
    },

    findDraggable: function (cell) {
        return this.map2d.getDraggable(cell.x, cell.y);
    },

    onRemoveValue: function (layer, x, y) {
        const tile = this.getCellLayerTile(layer, x, y);

        if (tile && tile.parent === this) {
            this.putTileInPool(tile);
        }
    },

    onSetValue: function (layer, x, y) {
        this.showLayerTile(layer, x, y);
    },

    onFogBlockSelected: function (fogBlock) {
        this.keyboardListener = cleverapps.inputDispatcher.on("keypressed", (key) => {
            if (Editor.currentEditor.boundsMode) {
                return;
            }

            const keys = {};
            const step = cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.shift) ? 5 : 1;

            keys[InputDispatcher.KEY.up] = { x: 0, y: -step };
            keys[InputDispatcher.KEY.down] = { x: 0, y: step };
            keys[InputDispatcher.KEY.left] = { x: -step, y: 0 };
            keys[InputDispatcher.KEY.right] = { x: step, y: 0 };

            if (keys[key]) {
                Editor.currentEditor.doCommand("moveRegion", {
                    code: fogBlock.id, dx: keys[key].x, dy: keys[key].y
                });
            }
        }, this);
    },

    onFogBlockUnselected: function () {
        if (this.keyboardListener) {
            this.keyboardListener.clear();
            delete this.keyboardListener;
        }
    },

    addDragAndProduceListener: function () {
        let isDoubleClick, touchUnit, touchObject;
        let produced, dragUnit, dragObject, highlight, startCell, areaSelectionStarted;
        let holdCell, holdTimer, pressTimer;
        let scrollDragOccurred;

        const HOLD_DELAY = 250;

        const calculateShift = (cell, touch) => {
            const cellPos = this.getCoordinatesByCell(cell);
            const touchPos = this.convertTouchToNodeSpace(touch);
            const cellSize = cleverapps.styles.Map2dView.cell;
            const sx = (touchPos.x - cellPos.x) / (cellSize.width / 2);
            const sy = (touchPos.y - cellPos.y) / (cellSize.height / 2);
            const round2 = (v) => Math.round(v * 100) / 100;
            return {
                x: Math.max(-0.5, Math.min(0.5, round2((sx + sy) / 2))),
                y: Math.max(-0.5, Math.min(0.5, round2((sy - sx) / 2)))
            };
        };

        const randomShift = () => ({
            x: Math.round((Math.random() - 0.5) * 100) / 100,
            y: Math.round((Math.random() - 0.5) * 100) / 100
        });

        const clearHold = () => {
            clearInterval(holdTimer);
            holdTimer = undefined;
            holdCell = undefined;

            clearTimeout(pressTimer);
            pressTimer = undefined;
        };

        const produce = (cell, touch) => {
            const key = Unit.GetPositionKey(cell);
            if (produced[key]) {
                return false;
            }
            const existingUnit = Map2d.currentMap.getUnit(cell.x, cell.y);
            const shift = touch && existingUnit && existingUnit.findComponent(Multiple)
                ? calculateShift(cell, touch) : undefined;
            if (!Editor.currentEditor.produce(cell.x, cell.y, undefined, shift)) {
                return false;
            }
            produced[key] = true;
            const placedUnit = Map2d.currentMap.getUnit(cell.x, cell.y);
            if (!holdTimer && placedUnit && placedUnit.findComponent(Multiple)) {
                holdCell = cell;
                holdTimer = setInterval(() => {
                    const count = Map2d.currentMap.getUnits(holdCell.x, holdCell.y)
                        .filter((u) => u.findComponent(Multiple)).length;
                    if (count >= Multiple.MAX_PER_CELL) {
                        clearHold();
                        return;
                    }
                    Editor.currentEditor.produce(holdCell.x, holdCell.y, undefined, randomShift());
                }, 400);
            }
            return true;
        };

        const finish = (cell) => {
            clearHold();
            scrollDragOccurred = false;

            if (areaSelectionStarted) {
                areaSelectionStarted = undefined;
            }

            if (produced) {
                produced = undefined;
            }

            if (dragObject) {
                if (!cell || !dragObject.canMoveTo(cell.x, cell.y)) {
                    cell = startCell;
                }

                dragObject.setPosition(cell.x, cell.y);
                dragObject = undefined;

                if (highlight) {
                    highlight.remove();
                    highlight = undefined;
                }
            }

            if (dragUnit) {
                dragUnit.onDragEnd();
                dragUnit = undefined;
            }

            isDoubleClick = undefined;
            touchUnit = undefined;
            touchObject = undefined;

            startCell = undefined;
        };

        cleverapps.UI.onDrag(this.editorControlsNode, {
            onPressed: (touch) => {
                if (touch.getButton() === 1) {
                    return false;
                }

                finish();

                const cell = this.getCellByTouch(touch);

                isDoubleClick = this._toolLastClick + PointerHandler.DOUBLE_CLICK_WAIT > Date.now();
                this._toolLastClick = Date.now();

                const object = this.findDraggable(cell);
                if (object) {
                    touchObject = object;
                    return false;
                }

                const unit = this.findTouchUnit(touch);
                if (unit && Editor.currentEditor.layer === Map2dEditor.LAYER_UNITS) {
                    touchUnit = unit;
                    return false;
                }

                pressTimer = setTimeout(() => {
                    pressTimer = undefined;
                    produced = {};
                    produce(cell, touch);
                }, HOLD_DELAY);

                return false;
            },

            onClick: (touch) => {
                const cell = this.getCellByTouch(touch);
                if (!cell) {
                    return;
                }

                if (!scrollDragOccurred) {
                    if (!produced) {
                        produced = {};
                        produce(cell, touch);
                    }

                    if (touchUnit && !produced[Unit.GetPositionKey(cell)]) {
                        if (isDoubleClick) {
                            this.map2d.selection.selectByDblClick(touchUnit, cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.ctrl));
                        } else if (Editor.currentEditor.layer === Map2dEditor.LAYER_UNITS) {
                            const selected = Editor.currentEditor && Editor.currentEditor.selected;
                            if (!selected || selected.eraser && selected.id !== MergeOrangery.DECORATOR_ID) {
                                const unitView = touchUnit.onGetView();
                                if (cleverapps.sceneDebugger.isSelected(unitView)) {
                                    cleverapps.sceneDebugger.unselectNodes();
                                } else {
                                    cleverapps.sceneDebugger.selectNode(unitView, { highlight: true, keepOnTouch: true });
                                }
                            }
                        }
                    }
                }

                finish();
            },

            onDragStart: (touch) => {
                clearTimeout(pressTimer);
                pressTimer = undefined;

                const cell = this.getCellByTouch(touch);
                if (!cell) {
                    return;
                }

                startCell = cell;

                if (touch.getButton() === 2) {
                    areaSelectionStarted = true;
                    touchUnit = undefined;
                    touchObject = undefined;
                    return true;
                }

                if (Editor.currentEditor.orangery.isBrushMode() && touch.getButton() === 0) {
                    if (!produced) {
                        produced = {};
                        produce(cell, touch);
                    }
                    return true;
                }

                if (touchObject) {
                    dragObject = touchObject;
                    highlight = new Highlight(cell.x, cell.y, { unit: dragObject });
                    Map2d.currentMap.onAnimationsAdd(highlight);
                    highlight.move(cell.x, cell.y, true);
                    return true;
                }

                if (touchUnit) {
                    if (cleverapps.sceneDebugger.selectedNode === touchUnit.onGetView() && touchUnit.onDragStart(touch)) {
                        dragUnit = touchUnit;
                        return true;
                    }
                }

                scrollDragOccurred = true;
                clearHold();
                produced = undefined;
            },

            onDragMoveNotThrottled: (touch, event, data) => {
                if (dragUnit) {
                    dragUnit.onFollowPointer(touch, data);
                }
                if (produced && !areaSelectionStarted) {
                    const cell = this.getCellByTouch(touch);
                    if (cell) {
                        produce(cell, touch);
                    }
                }
            },

            onDragMove: (touch) => {
                const cell = this.getCellByTouch(touch);
                if (!cell) {
                    return;
                }

                if (areaSelectionStarted) {
                    this.map2d.selection.selectUnitsInArea(startCell, cell, cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.ctrl));
                    return;
                }

                if (dragObject) {
                    dragObject.onDragMove(touch);
                    highlight.move(cell.x, cell.y);
                    return;
                }

                if (dragUnit) {
                    dragUnit.onDragMove();
                }
            },

            onDragEnd: (touch) => {
                const cell = this.getCellByTouch(touch);

                finish(cell);
            }
        });
    }
});
